import React from 'react';

const { UI } = Mobi2Go;

export default class StepperItem extends React.Component {
    render = () => (
        <div
            className={this.props.className}
            data-is-rendered={
                this.props.step_index === this.props.current_step ||
                this.props.step_index === this.props.current_step + 1 ||
                this.props.step_index === this.props.current_step - 1
            }
            data-is-showing={this.props.step_index === this.props.current_step}
            style={{
                transform: `translateY(${(this.props.step_index -
                    this.props.current_step) *
                    100}%)`,
            }}
        >
            {this.props.children}
        </div>
    );
}
